import React, { useState, useEffect } from "react";
import AddressItem from "../../../components/AddressItem";
import { useSelector } from "react-redux";
import { getContent } from "../../../utils/main";
import axios from "axios";
import AddressesPlaceholder from "./placeholders/AddressesPlaceholder";

const Addresses = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [isAddressesLoading, setIsAddressesLoading] = useState(true);
  const [addresses, setAddresses] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/main/departments/`)
      .then((res) => {
        setAddresses(res.data);
      })
      .then(() => {
        setIsAddressesLoading(false);
      });
  }, []);

  return (
    <div className="addresses-wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 page-section-title">
            <h4 className="title">
              {getContent(content, "Address maps header", lang)}
            </h4>
            <p className="content">
              {getContent(
                content,
                "Address mapping (also know as pin mapping or geocoding) is the process of assigning map coordinate locations to addresses in a database.",
                lang
              )}
            </p>
          </div>
        </div>
        {isAddressesLoading === true ? (
          <AddressesPlaceholder />
        ) : (
          <div className="row">
            {addresses.map((address) => (
              <AddressItem address={address} key={address.id} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Addresses;
